import { pointer } from 'd3';
export function getParentSVG(el) {
    var target = el;
    if (target === null)
        return null;
    if (target.tagName === 'svg')
        return target;
    while ((target === null || target === void 0 ? void 0 : target.parentElement) !== null) {
        target = target.parentElement;
        if (target.tagName === 'svg')
            return target;
    }
    return null;
}
export function getLocalPoint(event) {
    if (event.target === null)
        return null;
    var target = event.target;
    if (!target.classList.contains('Chart--TrackArea'))
        return null;
    var _a = pointer(event, target), mouseX = _a[0], mouseY = _a[1];
    var x = mouseX < 0 ? 0 : mouseX;
    var y = mouseY;
    return { x: x, y: y };
}
//# sourceMappingURL=utils.js.map